import { Box } from "@mui/material";
import "../../common/Common.css";
import { DataGrid } from "@mui/x-data-grid";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { DeletePatientButton, editPatientButton } from "../../common/commonStyles";
import DeleteIcon from "@mui/icons-material/Delete";

export default function BranchTable({ branchDetails, handleBranchtEdit }) {
  const columns = [
    {
      field: "name",
      headerName: "Branch",
      flex: 1,           
      minWidth: 120,       
      editable: false,
    },
    {
      field: "contact_number",
      headerName: "Phone",
      flex: 1,
      minWidth: 120,
      editable: false,
    },
    {
      field: "address",
      headerName: "Address",
      flex: 2,            
      minWidth: 150,
      editable: false,
    },
    {
      field: "start_time",
      headerName: "Start Time",
      flex: 1,
      minWidth: 100,
      editable: false,
    },
    {
      field: "close_time",
      headerName: "End Time",
      flex: 1,
      minWidth: 100,
      editable: false,
    },
    {
      field: "break_start_time",
      headerName: "Break Start",
      flex: 1,
      minWidth: 120,
      editable: false,
    },
    {
      field: "break_end_time",
      headerName: "Break End",
      flex: 1,
      minWidth: 120,
      editable: false,
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      flex: 0.8,          // 👈 smaller share
      minWidth: 100,
      renderCell: (param) => (
        <Box className="center-align">
          <BorderColorIcon
            sx={editPatientButton}
            onClick={() => handleBranchtEdit(param.row.id)}
          />
          <DeleteIcon
            sx={DeletePatientButton}
            onClick={() => {
              // handleServiceDelete(param.row.id);
            }}
          />
        </Box>
      ),
    },
  ];
  

  return (
    <Box sx={{ height: 400, width: "100%" }}>
      <DataGrid
        sx={{
          fontFamily: "Nunito, sans-serif",
          // Cell (row content) font size
          "& .MuiDataGrid-cell": {
            fontSize: "12px",
          },

          // Header font size
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "13px",
            fontWeight: "bold",
          },
        }}
        rows={branchDetails}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    </Box>
  );
}
